import React from 'react'
import { TextField, IconButton, CircularProgress, Box } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import DangerousIcon from '@mui/icons-material/Dangerous'
import { useStrings } from '../../assets/localization/strings'
import { extractUserMessageFromError } from '../../reusableUtils/Helpers'
import { ReactHookFormTextFieldStyle } from '../common/form/ReactHookFormTextField'

type Props = {
  coupon: string
  setCoupon: (value: string) => void
  state: Record<any, any> | Error | undefined
  load: () => any
  couponFocused: React.MutableRefObject<boolean>
}

export const CouponCodeView = ({ coupon, setCoupon, state, load, couponFocused }: Props) => {
  const strings = useStrings()
  const renderStatus = () => {
    if ((state == null && !couponFocused.current) || (state instanceof Error && (state as any).status !== 422)) return null

    if (state == null) {
      return (
        <IconButton disableRipple>
          <CircularProgress size={16} />
        </IconButton>
      )
    }

    if (state instanceof Error) {
      return (
        <IconButton onClick={load}>
          <DangerousIcon fontSize='small' color='error' />
        </IconButton>
      )
    }

    return (
      <IconButton disableRipple>
        <CheckCircleIcon fontSize='small' color='success' />
      </IconButton>
    )
  }

  const error = (() => {
    const message = extractUserMessageFromError(state)
    if (!message) return undefined

    try {
      const obj = JSON.parse(message)
      if ('key' in obj && 'args' in obj) {
        return strings[obj.key](...obj.args)
      }
      return undefined
    } catch {
      return undefined
    }
  })()

  return (
    <TextField
      {...ReactHookFormTextFieldStyle}
      fullWidth
      label={strings.discount}
      placeholder={strings.enter_discount_code}
      error={!!error}
      helperText={error}
      value={coupon}
      onChange={e => setCoupon(e.target.value)}
      InputLabelProps={{
        shrink: true // Forces the label to always float
      }}
      InputProps={{
        endAdornment: (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {coupon && renderStatus()}
          </Box>
        )
      }}
      sx={{
        mt: '20px',
        '& .MuiOutlinedInput-root': {
          minHeight: '36px',
          '& input': {
            padding: '14px 16px'
          }
        }
      }}
    />
  )
}
